import { useState, useContext } from "react";

import axios_api from "../Api";
import { API_URL, AUTH_TOKEN } from '../Context';


export default function TasksLoad(){

  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);

  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);

  const [startDate, setStartDate] = useState(today.toISOString().split('T')[0]);
  const [endDate, setEndDate] = useState(tomorrow.toISOString().split('T')[0]);

  const [formError, setFormError] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);


  const handleChangeStartDate = (event) => {
    setStartDate(event.target.value);
    setSuccessMessage(false);
  };

  const handleChangeEndDate = (event) => {
    setEndDate(event.target.value);
    setSuccessMessage(false);
  };


  const handleSubmit = (event) => {
    event.preventDefault(); // Предотвращаем перезагрузку страницы
   
    let params = {start_date: startDate, end_date: endDate}

    axios_api.post(api_url + `/sync_tasks/`, params, {
      headers: {
        "Authorization": token, 
        "Content-Type": "application/json",
      }
    })
    .then(
      (result) => {
        console.log("Task loading procedure started");
        setFormError(false)
        setSuccessMessage(true);
      },
      (error) => {
        setFormError(error.response.data)
        setSuccessMessage(false);
        console.log(error);
      }
    );
  }

 
  return (
    <>
      <div className="row">
        <h3 className="m-3">Загрузить задания из 1С</h3>
      </div>
      
      {successMessage && 
        <div class="alert alert-success m-3 py-2" role="alert">
          <div className="text-success">Задача на синхронизацию заданий успешно создана</div>
        </div>
      }
      <div className='row'>
        <div className="col-5 ms-3 lk-form">
          <form onSubmit={handleSubmit}>
            <div className="input-group my-3">
              <label className="mt-2">
                <p>дата начала</p>
                <input
                  type="date"
                  value={startDate}
                  onChange={handleChangeStartDate}
                />
                <span className="ms-2">00:00</span>
              </label>
            </div>

            <div className="input-group my-3">
              <label className="mt-3">
                <p>дата окончания</p>
                <input
                  type="date"
                  value={endDate}
                  onChange={handleChangeEndDate}
                />
                <span className="ms-2">00:00</span>
              </label>
            </div>

            {formError &&
              <p className="text-danger">{formError}</p>
            }
            
            {successMessage ?
              <button type="submit" className="btn lk-button my-3" disabled>Загрузить</button>
            :
              <button type="submit" className="btn lk-button my-3">Загрузить</button>
            }
          </form>
        </div>               
      </div> 
    </>
  )
}
